import { Icon, PublicButton } from '@yes.technology/react-toolkit'
import {
  getPublicButtonRest,
  isPublicButton,
  PublicButtonPropsWithType
} from 'shared/utils'
import { StyledButton } from './HeroBannerSecondary.styles'

export type HeroBannerSecondaryButtonProps = {
  button?: PublicButtonPropsWithType
  onClick: () => void
}

const HeroBannerSecondaryButton = ({
  button,
  onClick
}: HeroBannerSecondaryButtonProps) => {
  if (isPublicButton(button)) {
    return (
      <PublicButton
        {...getPublicButtonRest(button)}
        onClick={onClick}
        style={button?.style}
      >
        {button?.label ?? ''}
      </PublicButton>
    )
  }

  return (
    <StyledButton onClick={onClick} variant='secondary'>
      <Icon iconName='Information' />
    </StyledButton>
  )
}

export default HeroBannerSecondaryButton
